module.exports = __webpack_public_path__ + "static/media/info--mail.2f8f4967.svg";